export enum RequestFormFilesRoutePaths {
  Installer = 'installer',
  Client = 'client',
  Download = 'download',
}

export const RequestFormFilesTabTitles = {
  [RequestFormFilesRoutePaths.Installer]: 'От исполнителя',
  [RequestFormFilesRoutePaths.Client]: 'От заказчика',
  [RequestFormFilesRoutePaths.Download]: 'Скачать',
};

export const RequestFormFilesTabTitlesTranslateKeys = {
  [RequestFormFilesRoutePaths.Installer]: 'files_installer',
  [RequestFormFilesRoutePaths.Client]: 'files_client',
  [RequestFormFilesRoutePaths.Download]: 'files_download',
};
